import {
  BoxProps,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  Textarea,
  TextareaProps,
  InputProps,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { InputHTMLAttributes } from 'react';
import { useField } from 'formik';

type InputFieldProps = BoxProps &
  TextareaProps &
  InputProps &
  InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> & {
    name: string;
    label?: string;
    textarea?: boolean;
    row?: boolean;
    labelParams?: string[];
    errorParams?: string[];
    placeholderParams?: string[];
    format?: string;
  };

export const InputField: React.FC<InputFieldProps> = ({
  label,
  size: _,
  textarea = false,
  row = false,
  labelParams,
  errorParams,
  placeholderParams,
  format,
  ...props
}) => {
  const InputOrTextArea = textarea ? Textarea : Input;
  const [field, { error }] = useField(props);
  const translate = useTranslate();
  return (
    <FormControl isInvalid={!!error}>
      <Flex direction={row ? 'row' : 'column'} align="start">
        {!label || (
          <FormLabel htmlFor={field.name}>
            {translate(label, labelParams)}
          </FormLabel>
        )}

        <Flex w="full" direction="row" align="start">
          <InputOrTextArea
            {...field}
            {...props}
            id={field.name}
            placeholder={translate(props.placeholder, placeholderParams)}
            borderColor="#807a7a"
          />
          {format ? (
            <Text>{` ${translate('input-field.format')}: ${format}`}</Text>
          ) : null}
        </Flex>

        {error ? (
          <FormErrorMessage>{translate(error, errorParams)}</FormErrorMessage>
        ) : null}
      </Flex>
    </FormControl>
  );
};
